import { Injectable } from '@angular/core';
import { OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { OrderList } from 'primeng/primeng';
import { cartConfig } from '../../config/config';

@Injectable()
export class CartService implements OnInit {
  private isExistUrl;
  private addCartUrl;
  private AllCartUrl;
  private deleteCartUrl;
  private addOrderUrl;
  private orderListUrl;
  private deleteOrderUrl;
  private isExistOrderUrl;

  constructor(
    private http: HttpClient
  ) {
    this.addCartUrl = cartConfig.addCartUrl;
    this.AllCartUrl = cartConfig.AllCartUrl;
    this.deleteCartUrl = cartConfig.deleteCartUrl;
    this.addOrderUrl = cartConfig.addOrderUrl;
    this.orderListUrl = cartConfig.AllOrderUrl;
    this.deleteOrderUrl = cartConfig.deleteOrderUrl;
    this.isExistOrderUrl = cartConfig.isExistOrderUrl;
  }

  ngOnInit() {

  }

  /**
   * 获取所有的购物车
   * @param pageIndex
   * @param pageSize
   */
  getAllCart(pageIndex = 1, pageSize = 10) {
    const formdata = new FormData();
    formdata.append('currentPage', `${pageIndex}`);
    formdata.append('pageSize', `${pageSize}`);
    let access_token = sessionStorage.getItem("access_token");
    return this.http.post(this.AllCartUrl + "?access_token=" + access_token, formdata);
  }


  /**
  * 购物车添加
  * @param dataids
  */
  addCart(dataids) {
    let access_token = sessionStorage.getItem("access_token");
    return this.http.post(this.addCartUrl + "?dataids[]=" + dataids + "&num=0&access_token=" + access_token, {});
  }


  /**
   * 购物车删除
   * @param cartids
   */
  deleteCart(cartids) {
    let access_token = sessionStorage.getItem("access_token");
    return this.http.post(this.deleteCartUrl + "?dataid[]=" + cartids + "&access_token=" + access_token, {});
  }


  /**
   * 判断订单是否已经存在
   * @param dataids
   */
  isDownExist(dataids) {

    let access_token = sessionStorage.getItem("access_token");
    return this.http.post(this.isExistOrderUrl + "?dataids[]=" + dataids + "&access_token=" + access_token, {});
  }

  /**
   * 添加订单
   * @param dataids
   */
  addOrder(dataids) {
    let access_token = sessionStorage.getItem("access_token");
    return this.http.post(this.addOrderUrl + "?dataids[]=" + dataids + "&access_token=" + access_token, {});
  }


  /**
   * 获取所有订单
   */
  getAllOrder(currentPage, PageSize) {

    const formdata = new FormData();
    formdata.append('currentPage', currentPage);
    formdata.append('pageSize', PageSize);
    let access_token = sessionStorage.getItem("access_token");
    return this.http.post(this.orderListUrl + "?access_token=" + access_token, formdata);
  }


  /**
   * 订单删除
   */
  deleteOrder(orderids) {
    let access_token = sessionStorage.getItem("access_token");
    return this.http.post(this.deleteOrderUrl + "?orderIds[]=" + orderids + "&access_token=" + access_token, {});
  }

}
